import script from "./InfoCenterDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCenterDesktop.vue?vue&type=script&setup=true&lang=js"

import "./InfoCenterDesktop.vue?vue&type=style&index=0&id=0480dfce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0480dfce"]])

export default __exports__